import { render, staticRenderFns } from "./ParcelSellerBuyerSection.vue?vue&type=template&id=1161426c&scoped=true&"
import script from "./ParcelSellerBuyerSection.vue?vue&type=script&lang=js&"
export * from "./ParcelSellerBuyerSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelSellerBuyerSection.vue?vue&type=style&index=0&id=1161426c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1161426c",
  null
  
)

export default component.exports